// extracted by mini-css-extract-plugin
module.exports = {"articles":"Articles--articles--3ZWrH","articles__item":"Articles--articles__item--2oCXL","placeholderAnim":"Articles--placeholderAnim--1-vnR"};